// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';
// import { observable, computed, action } from 'mobx';

import BaseStore from '@core/stores/base';
import container from '@core/di';
import NotificationItemsService from '@shared/services/notification-items';
import NotificationItem, { NotificationItemDTO } from '@shared/models/dashboard/notification-item';
// import { ListRequestParams, PageInfo } from '@shared/types/services';

@injectable()
export default class NotificationItemsStore extends BaseStore<NotificationItemDTO, NotificationItem, NotificationItemsService> {
  static diToken = Symbol('notificationItems-store');
  /* Use baseclase???  Service must use the correct name for the virtual methods.
  @observable private _notificationItems: Array<NotificationItem> = [];
  @observable private _notificationItemsPageInfo: PageInfo;
  */
  constructor() {
    super({ service: container.get<NotificationItemsService>(NotificationItemsService.diToken) });
  }

  /* Use baseclass???
  @computed get notificationItems() {
    return this._notificationItems;
  }

  @computed get notificationItemssPageInfo() {
    return this._notificationItemsPageInfo;
  }

  // Get a notification given an Id.
  @action getNotificationItem = async (id: NotificationItemDTO['id']) => {
    return await this.service.get(id);
  }

  // Get a list of notifications and pagination info.
  @action getNotificationItems = async (params: ListRequestParams) => {
    this.loading.projections = true;

    try {
      const { items, pageInfo } = await this.service.getNotificationItems(params);

      this._notificationItems = items;
      this._notificationItemsPageInfo = pageInfo;

      this.loading.projections = false;
    } catch {
      this.loading.projections = false;
    }
  }
  */
}